(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-col-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.getElementById('compare-section-{{ section.id }}');
    if (!section) return;

    const btn = section.querySelector('[data-add-to-cart]');
    if (!btn) return;

    const feedback = section.querySelector('.cta-feedback');

    function showFeedback() {
      if (!feedback) return;
      feedback.style.display = 'inline';
      setTimeout(() => {
        feedback.style.display = 'none';
      }, 1800);
    }

    async function addToCart(endpoint, variantId, qty) {
      if (!variantId) {
        console.warn('No variant id available for this section.');
        return { ok: false, reason: 'no-variant' };
      }
      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty || 1 }), // keep id as string
        });
        if (!res.ok) {
          const text = await res.text().catch(() => '');
          console.error('Add to cart failed', res.status, text);
          return { ok: false, reason: 'http', status: res.status, body: text };
        }
        const item = await res.json().catch(() => ({}));
        // Common theme events
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item } }));
        document.dispatchEvent(new CustomEvent('cart:refresh')); // some themes listen for this
        return { ok: true, item };
      } catch (e) {
        console.error(e);
        return { ok: false, reason: 'exception', error: e };
      }
    }

    function openCartDrawerBestEffort() {
      // Try a few common patterns
      const drawerEl = document.querySelector('cart-drawer, #CartDrawer, [data-cart-drawer], .cart-drawer');
      if (drawerEl) {
        if (typeof drawerEl.open === 'function') drawerEl.open();
        drawerEl.classList.add('is-open', 'active', 'open');
        document.dispatchEvent(new CustomEvent('cart:drawer:open'));
        return true;
      }
      // Some themes watch for this only:
      document.dispatchEvent(new CustomEvent('openCartDrawer'));
      return false;
    }

    btn.addEventListener('click', async () => {
      const variantId = btn.getAttribute('data-variant-id'); // string, keep it
      const qty = btn.getAttribute('data-quantity') || '1';
      const after = btn.getAttribute('data-after') || 'drawer';
      const endpoint = btn.getAttribute('data-cart-endpoint') || '/cart/add.js';
      const productUrl = btn.getAttribute('data-product-url') || '/';

      btn.style.transform = 'translateY(-2px)';
      setTimeout(() => (btn.style.transform = ''), 140);

      const result = await addToCart(endpoint, variantId, qty);
      if (!result.ok) {
        // Helpful fallback: if missing variant, send the user to the product page to choose one
        if (result.reason === 'no-variant') {
          window.location.href = productUrl;
          return;
        }
        alert('Sorry—could not add to cart. Please try again.');
        return;
      }

      if (after === 'cart') {
        window.location.href = '/cart';
        return;
      }
      if (after === 'drawer') {
        const opened = openCartDrawerBestEffort();
        if (!opened) showFeedback();
        return;
      }
      showFeedback(); // after === 'stay'
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
